<template>
  <div>
    <div class="app-toolbar1">
      <el-button size="small" @click="toAdd" type="primary">添加</el-button>
      <el-button size="small" @click="load(1)">查询</el-button>
    </div>
    <el-table :data="rdbDataSources" :stripe="true" size="mini" v-loading="loading">
      <el-table-column prop="rdbDataSourceId" label="ID" width="80"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="136"></el-table-column>
      <el-table-column prop="projectName" label="所属项目"></el-table-column>
      <el-table-column prop="systemName" label="所属后端系统"></el-table-column>
      <el-table-column prop="name" label="数据源名称"></el-table-column>
      <el-table-column prop="type" label="类型" :formatter="typeFormatter" width="80"></el-table-column>
      <el-table-column prop="desc" label="描述" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="toUpdate(scope.row)" type="primary" size="small">修改</el-button>
          <el-button @click="toDelete(scope.row)" type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="query.total > 0" :page-size="query.limit" :pager-count="11" layout="total, prev, pager, next" :total="query.total" :background="true" @current-change="load" class="app-pagination"></el-pagination>

    <el-dialog :title="formTitle" :visible.sync="showForm" @close="resetForm">
      <el-form :model="form" :rules="formRule" ref="form" :status-icon="true" label-position="top">
        <el-form-item label="所属后端系统" prop="systemId">
          <el-select placeholder="请选择所属后端系统" v-model="form.systemId" style="width:100%">
            <el-option v-for="system in systems" :key="system.systemId" :value="system.systemId" :label="system.name">
              {{ system.name }}<span class="rds-option-desc">{{ system.projectName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入数据源的名称"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-radio-group v-model="form.type">
            <el-radio :border="true" label="MYSQL">Mysql</el-radio>
            <el-radio :border="true" label="ORACLE">Oracle</el-radio>
            <el-radio :border="true" label="SQL_SERVER">SQL Server</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="连接地址" prop="url">
          <el-input v-model="form.url" placeholder="请输入数据库的连接地址"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" placeholder="请输入数据库的用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" placeholder="请输入数据库的密码"></el-input>
        </el-form-item>
        <el-form-item label="表名匹配模式" prop="tableNamePattern">
          <el-input v-model="form.tableNamePattern" placeholder="请输入表名的匹配模式"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="desc">
          <el-input v-model="form.desc" placeholder="请输入数据源的描述" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showForm = false">取 消</el-button>
        <el-button type="primary" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { calcPage } from '../../util'

export default {
  name: 'rdb-data-source',
  data () {
    return {
      systems: [],
      loading: false,
      rdbDataSources: [],
      query: {
        page: 1,
        limit: 10,
        total: 0
      },
      showForm: false,
      formTitle: '添加关系型数据库数据源',
      form: {
        rdbDataSourceId: 0,
        systemId: 0,
        name: '',
        type: '',
        url: '',
        username: '',
        password: '',
        tableNamePattern: '',
        desc: ''
      },
      formRule: {
        systemId: [{ required: true, message: '请选择后端系统', trigger: 'change' }],
        name: [{ required: true, message: '请输入数据源的名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择数据库的类型', trigger: 'change' }],
        url: [{ required: true, message: '请输入数据库的连接地址', trigger: 'blur' }],
        username: [{ required: true, message: '请输入数据库的用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入数据库的密码', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.loadSystem()
    this.load(1)
  },
  methods: {
    loadSystem () {
      this.$http.request({
        method: 'get',
        url: '/api/cgSystems'
      }).then((res) => {
        this.systems = res.data.data || []
      })
    },
    load (page) {
      this.loading = true
      this.$http.request({
        method: 'get',
        url: `/api/cgRdbDataSources?page=${page}&limit=${this.query.limit}`
      }).then((res) => {
        let pageData = res.data.data
        this.rdbDataSources = pageData.data
        this.query.page = pageData.page
        this.query.total = pageData.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    toAdd () {
      this.formTitle = '添加关系型数据库数据源'
      this.form = { rdbDataSourceId: 0, systemId: null, name: '', type: '', url: '', username: '', password: '', tableNamePattern: '', desc: '' }
      this.showForm = true
    },
    toUpdate (row) {
      this.formTitle = '修改关系型数据库数据源'
      this.form = { rdbDataSourceId: row.rdbDataSourceId, systemId: row.systemId, name: row.name, type: row.type, url: row.url, username: row.username, password: row.password, tableNamePattern: row.tableNamePattern, desc: row.desc }
      this.showForm = true
    },
    toDelete (row) {
      this.$store.commit('confirm', { title: '提示', msg: '您确认要删除该关系型数据库数据源吗?', data: row, scope: this, callback: this.doDelete })
    },
    doSave () {
      this.$refs.form.validate((success) => {
        if (success) {
          let rdbDataSourceId = this.form.rdbDataSourceId
          this.$http.request({
            method: rdbDataSourceId === 0 ? 'post' : 'put',
            url: rdbDataSourceId === 0 ? '/api/cgRdbDataSources' : `/api/cgRdbDataSources/${rdbDataSourceId}`,
            data: JSON.stringify({
              systemId: this.form.systemId,
              name: this.form.name,
              type: this.form.type,
              url: this.form.url,
              username: this.form.username,
              password: this.form.password,
              tableNamePattern: this.form.tableNamePattern,
              desc: this.form.desc
            })
          }).then(() => {
            this.showForm = false
            this.load(this.query.page)
          })
        } else {
          return false
        }
      })
    },
    doDelete (result, data) {
      if (result) {
        this.$http.request({
          method: 'delete',
          url: `/api/cgRdbDataSources/${data.rdbDataSourceId}`
        }).then((res) => {
          if (res.data.status === 'yes') {
            this.$message.success('删除成功')
            this.load(calcPage(this.query))
          } else {
            this.$message.error(res.data.message || '删除失败')
          }
        })
      }
    },
    typeFormatter (row, column, cellValue) {
      let result = cellValue
      if (cellValue === 'MYSQL') {
        result = 'Mysql'
      } else if (cellValue === 'ORACLE') {
        result = 'Oracle'
      } else if (cellValue === 'SQL_SERVER') {
        result = 'SQL Server'
      }
      return result
    },
    resetForm () {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style>
.rds-option-desc{color:#8492a6;font-size:12px;margin-left:20px}
</style>
